/**
 * Scroll spy for the article table of contents ([data-post-toc]).
 * Anchor scrolling itself is native (scroll-margin-top on the headings).
 */
const HEADER_OFFSET = 130;

const initPostToc = () => {
  const toc = document.querySelector('[data-post-toc]');
  if (!toc) {
    return;
  }

  const links = Array.from(toc.querySelectorAll('.post-toc__link'));
  const headings = links
    .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
    .filter(Boolean);

  if (headings.length === 0) {
    return;
  }

  const spy = () => {
    let active = 0;
    headings.forEach((heading, index) => {
      if (heading.getBoundingClientRect().top - HEADER_OFFSET <= 0) {
        active = index;
      }
    });
    links.forEach((link, index) => link.classList.toggle('is-active', index === active));
  };

  links.forEach((link) => {
    link.addEventListener('click', () => {
      if (window.history.replaceState) {
        window.history.replaceState(null, '', link.hash);
      }
    });
  });

  window.addEventListener('scroll', spy, { passive: true });
  window.addEventListener('resize', spy, { passive: true });
  spy();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPostToc);
} else {
  initPostToc();
}
